import styled from 'styled-components';

import {flipOnLTR} from '~/shared/theme/utils';

const Root = styled.thead`
  height: 40px;
  max-height: 40px;
  overflow: hidden;
  ${({withRoundedCorners}) => withRoundedCorners && `
    display: block;
    border-radius: 8px;
    overflow: hidden;
  `}
`;

const CustomTableHeaderStyled = styled.tr`
  background: ${({theme, tableHeaderCustomColor}) => tableHeaderCustomColor || theme.userReport.general.header.background};
  display: flex;
  flex-wrap: nowrap;
  height: 40px;

  &.totalsRow {
    background-color: ${({theme}) => theme.userReport.general.markedRowBackground};
  }
`;

const CustomTableHeaderCell = styled.th`
  display: inline-block;
  width: ${({cellWidth}) => `${cellWidth}px`};
  font-weight: bold;
  color: ${({theme}) => theme.userReport.general.header.text};
  padding-top: 6px;
  ${flipOnLTR`
    text-align: right;
  `}
`;

const CustomTableHeader = ({columns, withRoundedCorners, tableHeaderCustomColor}) => {
  return (
    <Root withRoundedCorners={withRoundedCorners}>
      <CustomTableHeaderStyled tableHeaderCustomColor={tableHeaderCustomColor}>
        {columns?.map(({name, label, width}) => (
          <CustomTableHeaderCell key={name} cellWidth={width}>{label}</CustomTableHeaderCell>
        ))}
      </CustomTableHeaderStyled>
    </Root>
  );
};

export default CustomTableHeader;
